import { render, staticRenderFns } from "./MinorLoginError.vue?vue&type=template&id=b9fc2e5c&scoped=true"
import script from "./MinorLoginError.vue?vue&type=script&lang=js"
export * from "./MinorLoginError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fc2e5c",
  null
  
)

export default component.exports